import React from 'react';
import PropTypes from 'prop-types';
import LoginForm from '../components/LoginForm'
import {connect} from 'react-redux';
import {loginRequest, clearError} from '../actions/auth';

class Login extends React.Component {
  componentDidMount() {
    this.props.dispatch(clearError())
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const form = this.form
    const {location} = this.props
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {userName, password, remember} = values
      const redirectRoute = location.query.next || '/';
      this.props.dispatch(loginRequest({username: userName, password: password, remember: remember, nextUrl: redirectRoute}));
    });
  };

  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {fetching, error} = this.props
    return <LoginForm ref={this.saveFormRef} error={error} fetching={fetching} onSubmit={this.handleSubmit}/>
  }
}

Login.propTypes = {
  dispatch: PropTypes.func,
  fetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {error: state.auth.error, fetching: state.auth.fetching}
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.js